import React, { useEffect } from 'react';
import { NavHeader } from '../PageElements/NavHeader';
import Header from '../PageElements/Header';
import Footer from '../PageElements/Footer';
import '../CSS/MissionStatement.css';
import ScrollReset from '../Tools/ScrollReseter';

export default function MissionStatement() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <ScrollReset />
      <div className='wrapper'>
        <NavHeader maxScroll={200} windowWidth={windowWidth} />
        <Header
          imageURL={'Images/MissionStatement.png'}
          title={'Mission Statement'}
          titleSize={windowWidth > 750 ? 48 : 28}
          windowWidth={windowWidth}
        />
        <Content windowWidth={windowWidth}/>
        <Footer imageURL={'Images/MissionStatement.png'} windowWidth={windowWidth} />
      </div>
    </>
  );
}

function Content({windowWidth}) {
  return (
    <>
      <div className='content' style={{ display: 'flex', flexDirection: 'column', gap: '50px' }}>
        <TopImage />
        <Statement windowWidth={windowWidth}/>
      </div>
    </>
  );
}

function TopImage() {
  return (
    <>
      <div className='topImage'>
        <svg width='1' height='120' viewBox='0 0 1 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M0.5 0.231812V119.768' stroke='url(#paint0_linear_230_561)' />
          <defs>
            <linearGradient id='paint0_linear_230_561' x1='0.5' y1='0.306803' x2='26.0072' y2='5.7883' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#BC9C4E' />
            </linearGradient>
          </defs>
        </svg>

        <img
          className='headerImage'
          alt=''
          height={340}
          width={600}
          src='Images/MissionStatementTop.jpg'
          style={{ minWidth: '200px', maxWidth: '600px', height: 'auto', width: 'auto' }}
        />

        <svg width='1' height='120' viewBox='0 0 1 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M0.5 0.231812V119.768' stroke='url(#paint0_linear_230_561)' />
          <defs>
            <linearGradient id='paint0_linear_230_561' x1='0.5' y1='0.306803' x2='26.0072' y2='5.7883' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#BC9C4E' />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </>
  );
}

function Statement({windowWidth}) {
  return (
    <>
      <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
        {windowWidth > 1150 && (
          <svg width='86' height='100%' viewBox='0 0 86 430' fill='none' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M86 429H21C9.9543 429 0.999998 420.046 0.999998 409V21C0.999998 9.9543 9.9543 1 21 1H86'
              stroke='url(#paint0_linear_237_867)'
              strokeWidth='2'
            />
            <defs>
              <linearGradient id='paint0_linear_237_867' x1='1.00001' y1='214.802' x2='86.2255' y2='214.802' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#5472B8' />
                <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
              </linearGradient>
            </defs>
          </svg>
        )}

        <div style={{ width: '950px', gap: '8px', display: 'flex', justifyContent: 'center', alignItems: 'start', flexDirection: 'column' }}>
          <h1>Sókn Engineering Mission Statement</h1>

          <p style={{ paddingBottom: '12px' }}>
            At Sókn Engineering, we harness proprietary decryption mathematics and advanced AI to drive forecasting analytics that redefine the future
            of commodity markets. Our mission is to deliver unparalleled precision in forecasting, eliminate inefficiencies, and empower global
            institutions with actionable intelligence—transforming how commodity and real-world assets are understood, traded, and optimized. With a
            proven platform, scalable infrastructure, and access to multi-trillion-dollar market opportunities, Sókn is positioned to deliver
            exceptional value and long-term returns.
          </p>

          <p style={{ fontWeight: 'bold' }}>Company Values:</p>

          <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '2px', paddingLeft: '25px' }}>
            <li>
              <b>Integrity</b> – We do what’s right, always—with honesty, transparency, and accountability.
            </li>

            <li>
              <b>Originality</b> – We celebrate individuality and diversity as the foundation of groundbreaking innovation.
            </li>

            <li>
              <b>Bold Exploration</b> – We are fearless in challenging convention and pioneering new frontiers in finance and technology.
            </li>

            <li>
              <b>Ownership</b> – We lead with conviction, take responsibility for outcomes, and strive for excellence in both strategy and execution.
            </li>

            <li>
              <b>Thoughtful Precision</b> – We approach our work with intellectual depth and a disciplined, results-driven tempo.
            </li>

            <li>
              <b>People First</b> – We build enduring relationships by prioritizing empathy, respect, and collaboration in everything we do.
            </li>
          </ul>
        </div>

        {windowWidth > 1150 && (
          <svg width='86' height='100%' viewBox='0 0 86 430' preserveAspectRatio='none' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 429H65C76.0457 429 85 420.046 85 409V21C85 9.9543 76.0457 1 65 1H0' stroke='url(#paint0_linear_237_869)' strokeWidth='2' />
            <defs>
              <linearGradient id='paint0_linear_237_869' x1='85' y1='214.802' x2='-0.225464' y2='214.802' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#5472B8' />
                <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
              </linearGradient>
            </defs>
          </svg>
        )}
      </div>
    </>
  );
}
